@use "../partials/colors-ev";
@use "../partials/mixins";

$input-height: 48px;

// https://github.com/vercel/next.js/discussions/19417
// https://vitejs.dev/guide/features

.card__property {
  box-shadow: 0 8px 10px #efefef;

  &:hover {
    @apply bg-transparent;
  }

  // on-hover highlight
  [class~=MuiCardActionArea-focusHighlight] {
    @apply bg-transparent;
  }

  // effect on click
  [class~=MuiTouchRipple-child] {
    @apply bg-transparent;
  }
}

.chip__mls {
  background-color: colors-ev.$merino;
}

.pagination {
  button:not([class~='Mui-selected']):hover {
    @apply text-crimson;
  }
}

.card__icons {
  svg {
    width: 30px;
    height: 30px;
  }
}

[class~='MuiSkeleton-root'] {
  background-color: colors-ev.$merino;
}